"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioPill = function RadioPill(_ref) {
  var children = _ref.children,
      group = _ref.group,
      onChange = _ref.onChange,
      className = _ref.className,
      full = _ref.full,
      variant = _ref.variant,
      restProps = _objectWithoutProperties(_ref, ["children", "group", "onChange", "className", "full", "variant"]);

  return _react["default"].createElement(RadioPillContainer, {
    className: className,
    full: full,
    variant: variant
  }, _react["default"].Children.map(children, function (child) {
    if (child) {
      return _react["default"].cloneElement(child, _objectSpread2({}, child.props, {
        onChange: onChange,
        full: full,
        variant: variant,
        group: group
      }));
    }
  }));
};

RadioPill.themeProps = {
  container: {
    name: "RADIO_PILL",
    description: "Container style",
    type: _themeContants.themePropTypes.style
  }
};
var Full = (0, _styledComponents.css)(["display:flex;width:100%;"]);

var RadioPillContainer = _styledComponents["default"].div.withConfig({
  displayName: "RadioPill__RadioPillContainer",
  componentId: "iix176-0"
})(["border:0;margin:0;padding:0;outline:0;", ";", ";"], function (p) {
  return p.full && Full;
}, (0, _theming.applyVariants)(RadioPill.themeProps.container));

RadioPill.defaultProps = {
  onChange: null,
  full: false
};
RadioPill.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired,
  className: _propTypes["default"].string,
  group: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  full: _propTypes["default"].bool
};
var _default = RadioPill;
exports["default"] = _default;